export default __webpack_public_path__ + "static/media/shop-2x.efd9be54.jpg";